function getScreen() {
    var sinfo = {};
    sinfo.w = (window.screen.width).toString();
    sinfo.h = (window.screen.height).toString();
    sinfo.r = (window.devicePixelRatio >= 2 ? 1 : 0).toString();
    getScreen = function() {
        return sinfo;
    };
    return sinfo;
};
function isPlainObject( obj ) {
	if ( !obj || type(obj) !== "object") {
		return false;
	}
	try {
		if ( obj.constructor &&
			!{}.hasOwnProperty.call(obj, "constructor") &&
			!{}.hasOwnProperty.call(obj.constructor.prototype, "isPrototypeOf") ) {
			return false;
		}
	} catch ( e ) {
		return false;
	}
	var key;
	for ( key in obj ) {}

	return key === undefined || {}.hasOwnProperty.call( obj, key );
}
function type( obj ) {
	if ( obj == null ) {
		return String( obj );
	}
	return typeof obj === "object" || typeof obj === "function" ?
		{}[ {}.toString.call(obj) ] || "object" :
		typeof obj;
}
function getCookie(check_name) {
    // first we'll split this cookie up into name/value pairs
    // note: document.cookie only returns name=value, not the other components
    var a_all_cookies = document.cookie.split(';'),
        a_temp_cookie = '',
        cookie_name = '',
        cookie_value = '',
        length,
        b_cookie_found = false; // set boolean t/f default f

    for (i = 0, length = a_all_cookies.length; i < length; i++) {
        // now we'll split apart each name=value pair
        a_temp_cookie = a_all_cookies[i].split('=');
        // and trim left/right whitespace while we're at it
        cookie_name = a_temp_cookie[0].replace(/^\s+|\s+$/g, '');

        // if the extracted name matches passed check_name
        if (cookie_name == check_name) {
            b_cookie_found = true;
            // we need to handle case where cookie has no value but exists (no = sign, that is):
            if (a_temp_cookie.length > 1) {
                cookie_value = decodeURIComponent(a_temp_cookie[1].replace(/^\s+|\s+$/g, ''));
            }
            // note that in cases where cookie is initialized but no value, null is returned
            return cookie_value;
            break;
        }
        a_temp_cookie = null;
        cookie_name = '';
    }
    if (!b_cookie_found) {
        return null;
    }
}

module.exports = {
    getScreen: getScreen,
    isPlainObject: isPlainObject,
    getCookie: getCookie
}